import { useField } from 'react-final-form'

export const useIsGoogleLeadProject = () => {
  const {
    input: { value: lead_source },
  } = useField('lead_source', { subscription: { value: true } })
  return lead_source === 'GoogleLeads'
}
